import googleTagManager from '@analytics/google-tag-manager';
import { inject, provideAppInitializer } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as seline from '@seline-analytics/web';
import { IEnvironment } from '@sona/angular-util-environment';
import Analytics from 'analytics';
import { filter } from 'rxjs';

import { SonaAnalytics } from './analytics';

/**
 * Provides the global analytics Object and initializes the page tracking
 *
 * @param analyticsEnvironment - The Analytics environment configuration
 */
export const provideAnalytics = (
    analyticsEnvironment: IEnvironment['analytics']
) => {
    window.analytics = Analytics({
        app: 'siteboard',
        plugins: [ googleTagManager(analyticsEnvironment.googleTagManager) ]
    });

    if (analyticsEnvironment.seline.token) {
        seline.init({
            token: analyticsEnvironment.seline.token
        });
    } else {
        console.warn('Skipping Seline initialization due to missing token');
    }

    return provideAppInitializer(() => {
        const router = inject(Router);
        const analytics = inject(SonaAnalytics);

        router.events
            .pipe(
                filter(
                    (event): event is NavigationEnd =>
                        event instanceof NavigationEnd
                )
            )
            .subscribe(() => {
                analytics.page();
            });
      });
};
